import { FilterField } from '@/components/list-page'
import { BILLING_STATUS_LABELS } from '@/lib/billing/payment-labels'

/**
 * "Sem cobrança" não é status do enum — é a ausência dela. O backend traduz para
 * `billingId: null`. O valor tem de bater com `BILLING_STATUS_NONE` de
 * `libs/common/billing-status/billing-status-filter.ts`.
 */
export const BILLING_STATUS_NONE = 'NONE'

/**
 * Ordem de exibição: o ciclo normal da cobrança primeiro, os desfechos depois.
 * `Object.keys` do mapa de rótulos daria a ordem de declaração, que não é a que o
 * operador procura.
 */
const ORDEM = [
    'PENDING',
    'PAID',
    'PARTIALLY_PAID',
    'OVERDUE',
    'CANCELLED',
    'REFUNDED',
    'PARTIALLY_REFUNDED',
    'IN_DISPUTE',
    'WRITTEN_OFF',
]

/**
 * Filtro de status de pagamento das listagens de atendimento.
 *
 * Compartilhado entre consultas, exames e procedimentos: são a mesma pergunta
 * ("o que ainda não foi pago?") e a lista de status não pode divergir entre elas.
 */
export function BillingStatusFilter({
    value,
    onChange,
    id = 'filtro-status-pagamento',
    allowNone = true,
    className = 'w-full sm:w-48',
}: {
    value: string
    onChange: (value: string) => void
    id?: string
    /**
     * Oferecer "Sem cobrança". Falso no dashboard financeiro: lá o universo já é
     * o das cobranças, e a opção só devolveria tela vazia.
     */
    allowNone?: boolean
    className?: string
}) {
    return (
        <FilterField label="Pagamento" htmlFor={id} className={className}>
            <select
                id={id}
                className="select select-bordered select-sm w-full"
                value={value}
                onChange={e => onChange(e.target.value)}
            >
                <option value="">Todos</option>
                {ORDEM.map(status => (
                    <option key={status} value={status}>
                        {BILLING_STATUS_LABELS[status] ?? status}
                    </option>
                ))}
                {allowNone && (
                    <option value={BILLING_STATUS_NONE}>Sem cobrança</option>
                )}
            </select>
        </FilterField>
    )
}
